const shapeData = (customers) =>
  customers.data.map((customer) => ({
    ...customer,
    hasLogo: !!customer.logo,
  }));

export { shapeData };
